import { colorPalette } from "theme"

export const JinxSodaLogoStacked = () => {
  return (
    <svg id="Layer_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 583.54 506.18" height={400} width={400}>
      <path
        className="cls-1"
        fill={colorPalette.blue}
        d="m432.68,89.24c-7.44-2.14-13.87-6.67-19.47-12.02-10.34-9.89-26.81-9.76-36.98.41-18.06,18.07-47.46,18.07-65.53,0-10.31-10.31-27.09-10.31-37.41,0-18.06,18.07-47.46,18.07-65.53,0-10.17-10.17-26.64-10.31-36.98-.42-5.6,5.35-12.02,9.89-19.47,12.02-17.38,4.99-34.82.26-46.78-11.9-10.13-10.3-26.9-9.92-37.12.29h0c-3.88,3.88-10.18,3.88-14.06,0l-.75-.75c-3.47-3.47-3.47-9.09,0-12.56h0c7.61-7.61,17.45-12.82,28.14-14.02,14.35-1.6,28.13,3.26,38.13,13.27,10.25,10.25,26.89,10.31,37.22.19,5.63-5.52,12.33-9.92,19.94-11.99,17-4.63,34,.03,45.78,11.81,10.25,10.25,26.89,10.31,37.22.18,5.63-5.52,12.33-9.92,19.94-11.99,17-4.63,34,.03,45.78,11.81,10.31,10.32,27.1,10.31,37.41,0,18.07-18.07,47.47-18.06,65.53,0,10.25,10.25,26.9,10.31,37.23.18,5.63-5.52,12.32-9.91,19.93-11.98,17-4.63,34,.03,45.78,11.8h0c3.88,3.88,3.88,10.18,0,14.06h0c-3.88,3.88-10.18,3.88-14.06,0h0c-10.22-10.22-26.99-10.59-37.12-.29-11.95,12.16-29.4,16.89-46.78,11.9Z"
      />
      <path
        className="cls-1"
        fill={colorPalette.blue}
        d="m236.39,149.53v103h34.61v19.09h-93.47v-19.09h34.41v-103h-34.41v-19.09h93.47v19.09h-34.61Z"
      />
      <path
        className="cls-1"
        fill={colorPalette.blue}
        d="m374.02,236.82h.8c-.8-5.57-1.19-13.32-1.19-19.09v-87.29h22.87v141.18h-28.46l-37.16-90.67c-3.18-7.56-5.77-16.7-6.36-18.49h-.99c.8,4.57,1.19,10.94,1.19,16.11v93.06h-22.87v-141.18h30.85l34.58,86.5c3.38,8.35,5.77,15.91,6.76,19.88Z"
      />
      <path
        className="cls-1"
        fill={colorPalette.blue}
        d="m458.33,197.06l-37.38-66.61h26.84l19.88,40.37c2.58,5.37,4.18,8.75,4.77,13.72h.8c.6-4.97,1.99-8.15,4.57-13.32l19.69-40.76h26.65l-36.59,67.61,42.15,73.57h-27.84l-24.46-48.12c-3.18-6.36-3.98-8.95-4.57-12.92h-.79c-.4,3.98-1.19,6.56-4.77,13.32l-24.06,47.72h-26.84l41.96-74.57Z"
      />
      <path
        className="cls-1"
        fill={colorPalette.blue}
        d="m173.78,389.37v-14.32c0-41.56,17.3-66.81,52.69-66.81s52.7,25.25,52.7,66.81v14.32c0,41.56-17.3,66.81-52.7,66.81s-52.69-25.25-52.69-66.81Zm80.33.6v-15.51c0-31.82-8.55-46.13-27.64-46.13s-27.64,14.32-27.64,46.13v15.51c0,31.82,8.55,46.13,27.64,46.13s27.64-14.32,27.64-46.13Z"
      />
      <path
        className="cls-1"
        fill={colorPalette.blue}
        d="m346.98,311.62c37.18,0,58.26,28.24,58.26,68.6v2.58c0,40.56-22.87,69.99-58.66,69.99h-44.74v-141.18h45.14Zm33.21,71.19v-2.58c0-28.44-11.53-49.11-34.8-49.11h-19.09v102.21h18.69c22.87,0,35.19-22.07,35.19-50.51Z"
      />
      <path
        className="cls-1"
        fill={colorPalette.blue}
        d="m495.32,416.81h-44.74l-10.14,35.99h-24.06l42.55-141.18h28.24l42.55,141.18h-24.06l-10.34-35.99Zm-39.17-19.69h33.61c-7.96-26.84-13.13-47.92-16.31-65.22h-.8c-3.18,17.3-8.55,38.38-16.5,65.22Z"
      />
      <path
        className="cls-1"
        fill={colorPalette.blue}
        d="m146.52,130.43v98.43c0,29.03-18.29,46.13-47.33,46.13-32.19,0-46.51-22.67-47.5-48.92-.13-2.96,0-10.65,0-10.65h24.41s0,1.39.04,3.49c.2,22.67,8.55,35.59,24.06,35.59,16.28,0,21.85-11.93,21.85-28.63v-74.79h-58.75v-20.66h83.21Z"
      />
      <path
        className="cls-1"
        fill={colorPalette.blue}
        d="m117.69,372.86l-18.67-5.17c-11.53-3.38-19.49-10.14-19.49-20.68,0-9.15,5.57-18.89,22.87-18.89,11.59,0,22.85,4.86,28.35,18.95,1.05,3.21,1.18,7.04,1.18,7.04,0,0,22.61,0,22.61,0,.03-.13-.37-5.98-.41-6.38-.16-1.5-.32-3.02-.64-4.5-5.37-24.46-25.25-35-50.88-35-28.44,0-47.72,18.1-47.72,41.56,0,21.47,14.52,33.8,35.4,39.37l18.87,5.17c11.14,2.98,20.48,6.96,20.48,22.47s-13.5,19.09-24.83,19.09c-3.2,0-6.41-.34-9.51-1.15-4.4-1.15-8.55-3.29-12.08-6.16-3.2-2.61-5.7-5.73-7.47-9.26-2.18-4.47-2.45-11.33-2.45-11.33h-22.26s.06,2.29.07,2.43c.09,1.77.35,3.52.61,5.27s.6,3.61,1.04,5.39c2.87,11.62,10.51,21.44,20.81,27.53,9.17,5.42,19.88,7.56,30.44,7.56,33.78,0,50.49-20.68,50.49-42.55,0-26.25-17.1-35.4-36.79-40.76Z"
      />
    </svg>
  )
}
